module.exports = __webpack_public_path__ + "img/hero.fe6569a4.webp";